export default "/assets/images/filter-04.2de77b73c1b3979a.svg";